// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActivityFilterController from "./activity_filter_controller"
import AiOutreachController from "./ai_outreach_controller"
import AiProspectSearchController from "./ai_prospect_search_controller"
import AddressController from "./address_controller"
import CampSearchController from "./camp_search_controller"
import AdminMenuController from "./admin_menu_controller"
import ChoicesRecipientController from "./choices_recipient_controller"
import DropzoneController from "./dropzone_controller"
import FlashController from "./flash_controller"
import HelloController from "./hello_controller"
import MobileMenuController from "./mobile_menu_controller"
import QuestAccordionController from "./quest_accordion_controller"
import MobileUserMenuController from "./mobile_user_menu_controller"
import PasskeyController from "./passkey_controller"
import PhoneMaskController from "./phone_mask_controller"
import QuestNestableController from "./quest_nestable_controller"
import QuestSortableController from "./quest_sortable_controller"
import RejectModalController from "./reject_modal_controller"
import TaskSortableController from "./task_sortable_controller"
import ToggleController from "./toggle_controller"
import UppyUploadController from "./uppy_upload_controller"
import SignaturePadController from "./signature_pad_controller"
import TemplateVariablesController from "./template_variables_controller"

application.register("activity-filter", ActivityFilterController)
application.register("ai-outreach", AiOutreachController)
application.register("ai-prospect-search", AiProspectSearchController)
application.register("address", AddressController)
application.register("camp-search", CampSearchController)
application.register("admin-menu", AdminMenuController)
application.register("choices-recipient", ChoicesRecipientController)
application.register("dropzone", DropzoneController)
application.register("flash", FlashController)
application.register("hello", HelloController)
application.register("mobile-menu", MobileMenuController)
application.register("passkey", PasskeyController)
application.register("mobile-user-menu", MobileUserMenuController)
application.register("phone-mask", PhoneMaskController)
application.register("quest-accordion", QuestAccordionController)
application.register("quest-nestable", QuestNestableController)
application.register("quest-sortable", QuestSortableController)
application.register("reject-modal", RejectModalController)
application.register("task-sortable", TaskSortableController)
application.register("toggle", ToggleController)
application.register("uppy-upload", UppyUploadController)
application.register("signature-pad", SignaturePadController)
application.register("template-variables", TemplateVariablesController)
